import { Link, Route } from "react-router-dom/cjs/react-router-dom.min";
import BusinessDigitalTwin from "./BusinessDigitalTwin";
import BusinessGeoIot from "./BusinessGeoIot";
import BusinessGis from "./BusinessGis";
import BusinessAi from "./BusinessAi";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";

function Business({ match }) {
  const [name, setName] = useState("");
  const [cont1, setCont1] = useState("");
  const [cont2, setCont2] = useState("");

  const getData = (name, cont1, cont2) => {
    setName(name);
    setCont1(cont1);
    setCont2(cont2);
  };

  const btnBox = document.getElementsByClassName("basic-item")[0];
  const link = document.location.href;

  //링크에 따른 클래스 부여
  if (link.includes("digitaltwin")) {
    classRemove(btnBox?.children);
    btnBox?.children[0].classList.add("on");
  } else if (link.includes("geo-iot")) {
    classRemove(btnBox?.children);
    btnBox?.children[1].classList.add("on");
  } else if (link.includes("gis")) {
    classRemove(btnBox?.children);
    btnBox?.children[2].classList.add("on");
  } else if (link.includes("ai")) {
    classRemove(btnBox?.children);
    btnBox?.children[3].classList.add("on");
  }

  //버튼 클릭시 이동(임시)
  const onMovePage = (e) => {
    const targetValue = e.target;

    classRemove(btnBox?.children);
    targetValue.parentNode.classList.add("on");
  };

  //on 클래스 삭제
  function classRemove(arr) {
    for (let i = 0; i < arr?.length; i++) {
      arr[i].classList.remove("on");
    }
  }

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      <div className="basic-main">
        <div className="basic-visual business-visual">
          <div className="inner">
            <h2 className="basic-visual-title">{name}</h2>
            <div className="basic-visual-cont">
              {pc ? (
                <>
                  <p>{cont1}</p>
                  <p>{cont2}</p>
                </>
              ) : (
                <>
                  <p>
                    {cont1}
                    {cont2}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="basic-tap">
          <ul className="basic-item" onClick={onMovePage}>
            <li className="basic-list">
              <Link to="/business/digitaltwin" className="basic-link">
                Digital Twin
              </Link>
              <span className="line"></span>
            </li>
            <li className="basic-list">
              <Link to="/business/geo-iot" className="basic-link">
                Geo-IoT
              </Link>
              <span className="line"></span>
            </li>
            <li className="basic-list">
              <Link to="/business/gis" className="basic-link">
                GIS
              </Link>
              <span className="line"></span>
            </li>
            <li className="basic-list">
              <Link to="/business/ai" className="basic-link">
                AI
              </Link>
              <span className="line"></span>
            </li>
          </ul>
        </div>
      </div>
      <div className="basic-inner">
        <Route
          path={`${match.path}/digitaltwin`}
          exact={true}
          render={() => <BusinessDigitalTwin getData={getData} />}
        />
        <Route
          path={`${match.path}/geo-iot`}
          render={() => <BusinessGeoIot getData={getData} />}
        />
        <Route
          path={`${match.path}/gis`}
          render={() => <BusinessGis getData={getData} />}
        />
        <Route
          path={`${match.path}/ai`}
          render={() => <BusinessAi getData={getData} />}
        />
      </div>
    </>
  );
}

export default Business;
